import React, { useEffect, useState } from 'react';
import LayoutType from 'src/shared/utils/layout_type';
import UserIcon from 'images/user-icon.png';
import Cookies from 'js-cookie';
import { ChevronDownIcon } from 'lucide-react';

import LoginModal from "src/shared/components/LoginModal";

import { Link as LinkRR } from 'react-router-dom';

import {
  NavbarItem,
  DropdownItem,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  Button,
  User,
  useDisclosure
} from "@heroui/react";

import { useGetCurrentUserQuery, useLogoutMutation } from 'src/services/rtk_api/user/sessionApi';
import classNames from 'classnames';

const Anonymous = ({reloadDocument, onSignInClick }) => {
  return (
    <NavbarItem className="">
      <Button color="default" size="sm" className="button-login rounded" reloadDocument={reloadDocument} onClick={onSignInClick}>Sign in</Button>
    </NavbarItem>
  )
}

const MenuAccount = ({layoutType}) => {

  const { data: currentUser, refetch, isLoading, error } = useGetCurrentUserQuery(undefined, {
    refetchOnMountOrArgChange: true
  });
  const [logout, {isSuccess: logoutSuccess}] = useLogoutMutation();
  const {isOpen: isModalOpen, onOpen: onModalOpen, onOpenChange: onModalOpenChange} = useDisclosure();

  const reloadFrontLink = layoutType !== LayoutType.FRONT_SITE;
  const reloadAccountLink = layoutType !== LayoutType.ACCOUNT_SITE;

  const handleLogout = (e) => {
    logout();
  }

  useEffect(() => {
    if (logoutSuccess) {
      Cookies.remove('spree_bearer_token');
      window.location.href = '/'
    }
  }, [logoutSuccess])

  if (isLoading || !currentUser || error) {
    return (
      <>
        <Anonymous reloadDocument={reloadFrontLink} onSignInClick={onModalOpen}/>
        <LoginModal
          mode={"LOGIN"}
          isOpen={isModalOpen}
          onOpenChange={onModalOpenChange}
          onOk={() => {
            if(window.location.pathname === '/reset-password') {
              window.location.href = '/';
            }
          }}
        />
      </>
    )
  }

  const hasAvatar = !!currentUser.avatar_url;
  const initials = `${currentUser.first_name?.[0] || ''}${currentUser.last_name?.[0] || ''}`.toUpperCase();

  // Note: remove padding from dropdown item so the inside link use all space available to click
  return (
    <>
      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <NavbarItem>
            <div className="text-white font-medium flex gap-1 items-center cursor-pointer">
              <User
                as="div"
                className="text-white"
                avatarProps={{
                  src: hasAvatar ? currentUser.avatar_url : undefined,
                  size: "sm",
                  name: !hasAvatar ? initials : undefined,
                  className: "bg-gray-500 text-white font-semibold"
                }}
              />
              <ChevronDownIcon size={16} />
            </div>
          </NavbarItem>
        </DropdownTrigger>
        <DropdownMenu aria-label="Profile Actions" variant="flat" itemClasses={{
          base: [
            'px-0',
            'py-0',
          ],
        }}>
          <DropdownItem key="profile" textValue="signed as" isReadOnly
                        className="h-14 gap-2 px-2 py-1.5 cursor-default">
            <p className="font-semibold">Signed in as</p>
            <p className="font-semibold">{currentUser.email}</p>
          </DropdownItem>
          <DropdownItem key="user_settings" textValue="profile">
            <LinkRR to="/account" reloadDocument={reloadAccountLink} className="px-2 py-1.5 block">Profile</LinkRR>
          </DropdownItem>
          { 
            process.env.ALLOW_TEAMS === 'true' &&
              <DropdownItem key="team_settings" textValue="teams">
                <LinkRR to="/account/teams" reloadDocument={reloadAccountLink} className="px-2 py-1.5 block">Team</LinkRR>
              </DropdownItem>
          }
          <DropdownItem key="analytics" textValue="my BOMs">
            <LinkRR reloadDocument={reloadAccountLink} to="/account/my-boms" className="px-2 py-1.5 block">Projects</LinkRR>
          </DropdownItem>
          { 
            process.env.CHARGE_CREDITS_ON_QUOTE === 'true' && 
              <DropdownItem key="wallet_transactions" textValue="Wallet Transactions">
                <LinkRR reloadDocument={reloadAccountLink} to="/account/wallet" className="px-2 py-1.5 block">Wallet Transactions</LinkRR>
              </DropdownItem>
          }
          { 
            process.env.CHARGE_CREDITS_ON_QUOTE === 'true' && 
              <DropdownItem key="orders" textValue="orders">
                <LinkRR reloadDocument={reloadAccountLink} to="/account/orders" className="px-2 py-1.5 block">Orders</LinkRR>
              </DropdownItem>
          }
          <DropdownItem key="addresses" textValue="addresses">
            <LinkRR reloadDocument={reloadAccountLink} to="/account/addresses" className="px-2 py-1.5 block">Addresses</LinkRR>
          </DropdownItem>
          <DropdownItem key="vendors" textValue="vendor integrations">
            <LinkRR reloadDocument={reloadAccountLink} to="/account/suppliers" className="px-2 py-1.5 block">
              Suppliers
            </LinkRR>
          </DropdownItem>
          <DropdownItem key="settings" textValue="my settings">
            <LinkRR reloadDocument={reloadAccountLink} to="/account/preferences" className="px-2 py-1.5 block">Preferences</LinkRR>
          </DropdownItem>
          <DropdownItem key="logout" color="danger" className="px-2 py-1.5" onPress={handleLogout}>
            Log Out
          </DropdownItem>
          {/*<LogOut />*/}
        </DropdownMenu>
      </Dropdown>
    </>
  )
};

export default MenuAccount;
